import { Component, OnInit, OnDestroy } from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs/Rx';
import { EventManager, ParseLinks, PaginationUtil, JhiLanguageService, AlertService } from 'ng-jhipster';

import { Payment, PaymentType } from './payment.model';
import { Student, StudentTypeaheadService } from '../student';
import { PaymentService } from './payment.service';
import { ITEMS_PER_PAGE, Principal, FUZZY_SEARCH_DISTANCE } from '../../shared';
import { PaginationConfig } from '../../blocks/config/uib-pagination.config';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap/datepicker/ngb-date-struct';

@Component({
    selector: 'jhi-payment',
    templateUrl: './payment.component.html'
})
export class PaymentComponent implements OnInit, OnDestroy {

    currentAccount: any;
    payments: Payment[];
    error: any;
    success: any;
    eventSubscriber: Subscription;
    routeData: any;
    links: any;
    totalItems: any;
    queryCount: any;
    itemsPerPage: any;
    page: any;
    predicate: any;
    previousPage: any;
    reverse: any;

    // Search parameters
    currentSearchByPayer: Student;
    currentSearchByPaymentType: string;
    currentSearchByCreatedDateFrom: NgbDateStruct;
    currentSearchByCreatedDateTo: NgbDateStruct;
    formattedQuery: string;

    searchPayer = this.studentTypeaheadService.search;
    resultFormatter = this.studentTypeaheadService.resultFormatter;
    inputFormatter = (student: any) => this.studentTypeaheadService.inputFormatter(student, () => this.currentSearchByPayer['user']);


    constructor(
        private jhiLanguageService: JhiLanguageService,
        private paymentService: PaymentService,
        private parseLinks: ParseLinks,
        private alertService: AlertService,
        private principal: Principal,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private eventManager: EventManager,
        private studentTypeaheadService: StudentTypeaheadService,
        private paginationUtil: PaginationUtil,
        private paginationConfig: PaginationConfig
    ) {
        this.itemsPerPage = ITEMS_PER_PAGE;
        this.jhiLanguageService.setLocations(['payment', 'paymentType']);
        this.routeData = this.activatedRoute.data.subscribe(data => {
            this.page = data['pagingParams'].page;
            this.previousPage = data['pagingParams'].page;
            this.reverse = data['pagingParams'].ascending;
            this.predicate = data['pagingParams'].predicate;
        });
        this.formattedQuery = activatedRoute.snapshot.params['formattedSearch'] ? activatedRoute.snapshot.params['formattedSearch'] : '';
        if (this.formattedQuery) {
            this.currentSearchByPaymentType = activatedRoute.snapshot.params['paymentType'];
            this.currentSearchByPayer = activatedRoute.snapshot.params['studentLabel'] ?
            activatedRoute.snapshot.params['studentLabel'] : '';
            this.currentSearchByCreatedDateFrom = {
                year: parseInt(activatedRoute.snapshot.params['yearFrom'], 10),
                month:  parseInt(activatedRoute.snapshot.params['monthFrom'], 10),
                day:  parseInt(activatedRoute.snapshot.params['dayFrom'], 10)
            };
            this.currentSearchByCreatedDateTo = {
                year: parseInt(activatedRoute.snapshot.params['yearTo'], 10),
                month:  parseInt(activatedRoute.snapshot.params['monthTo'], 10),
                day:  parseInt(activatedRoute.snapshot.params['dayTo'], 10)
            };
        }

    }

    loadAll() {
        if (this.formattedQuery) {
            this.paymentService.search({
                page: this.page - 1,
                query: this.formattedQuery,
                size: this.itemsPerPage,
                sort: this.sort()
            }).subscribe(
                (res: HttpResponse<Payment[]>) => this.onSuccess(res.body, res.headers),
                (res: HttpErrorResponse) => this.onError(res)
                );
            return;
        }
        this.paymentService.query({
            page: this.page - 1,
            size: this.itemsPerPage,
            sort: this.sort()
        }).subscribe(
            (res: HttpResponse<Payment[]>) => this.onSuccess(res.body, res.headers),
                (res: HttpErrorResponse) => this.onError(res)
                );
    }
    loadPage(page: number) {
        if (page !== this.previousPage) {
            this.previousPage = page;
            this.transition();
        }
    }
    transition() {
        let params = {
            formattedSearch: this.formattedQuery,
            page: this.page,
            size: this.itemsPerPage,
            sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
        };
        if (this.currentSearchByPayer) {
            params['studentLabel'] = this.currentSearchByPayer;
        }
        this.router.navigate(['/payment'], {
            queryParams: params
        });
        this.loadAll();
    }

    clear() {
        this.page = 0;
        this.currentSearchByPayer = null;
        this.currentSearchByPaymentType = null;
        this.currentSearchByCreatedDateFrom = null;
        this.currentSearchByCreatedDateTo = null;
        this.formattedQuery = '';
        this.router.navigate(['/payment', {
            page: this.page,
            sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
        }]);
        this.loadAll();
    }

    search() {
        this.page = 0;
        this.formattedQuery = this.getQuery();
        if (!this.formattedQuery) {
            return this.clear();
        }
        let params = {
            formattedSearch: this.formattedQuery,
            page: this.page,
            sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
        };

        if (this.currentSearchByPayer) {
            params['studentLabel'] = this.currentSearchByPayer;
        }

        this.router.navigate(['/payment', params ]);
    }

    private getDateRangeQuery(from: NgbDateStruct, to: NgbDateStruct): string {
        let fromDate = new Date(from.year, from.month - 1, from.day);
        let toDate = new Date(to.year, to.month - 1, to.day);
        let fromDateString = fromDate.toISOString().split('T')[0];
        let toDateString = toDate.toISOString().split('T')[0];
        return 'createdDate:[' + fromDateString + ' TO ' + toDateString + ']';
    }

    getQuery(): string {
        let operators = [];

        if (this.currentSearchByPaymentType) {
            operators.push('type:' + this.currentSearchByPaymentType);
        }

        if (this.currentSearchByCreatedDateFrom && this.currentSearchByCreatedDateTo) {
            operators.push(this.getDateRangeQuery(this.currentSearchByCreatedDateFrom, this.currentSearchByCreatedDateTo));
        }

        if (this.currentSearchByPayer && this.currentSearchByPayer.id) {
            operators.push('payer.id:' + this.currentSearchByPayer.id);
        }

        return operators.reduce((query, operator, i) => {
            query = query + operator + ((i < operators.length - 1) ? ' AND ' : '');
            return query;
        }, '');
    }

    ngOnInit() {
        this.loadAll();
        this.principal.identity().then((account) => {
            this.currentAccount = account;
        });
        this.activatedRoute.params.subscribe((params) => {
            this.loadAll();
        });
        this.registerChangeInPayments();
    }

    ngOnDestroy() {
        this.eventManager.destroy(this.eventSubscriber);
    }

    trackId(index: number, item: Payment) {
        return item.id;
    }

    registerChangeInPayments() {
        this.eventSubscriber = this.eventManager.subscribe('paymentListModification', (response) => this.loadAll());
    }

    sort() {
        let result = [this.predicate + ',' + (this.reverse ? 'asc' : 'desc')];
        return result;
    }

    createdDateFromChanged(event) {
        // Nothing to do
    }

    isSearchActive() {
        return (this.currentSearchByCreatedDateFrom && this.currentSearchByCreatedDateTo) ||
        this.currentSearchByPayer  || this.currentSearchByPaymentType ;
    }

    private onSuccess(data, headers) {
        this.links = this.parseLinks.parse(headers.get('link'));
        this.totalItems = headers.get('X-Total-Count');
        this.queryCount = this.totalItems;
        // this.page = pagingParams.page;
        this.payments = data;
    }

    private onError(error: HttpErrorResponse) {
        this.alertService.error(error.error, null, null);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/payment/payment.component.ts